import { makeStyles, mergeClasses, shorthands } from '@griffel/react';

import { coreuiTokens, tokens } from '../../../util/theme/fluent9';

export const useClasses = makeStyles({
  fullWidth: {
    width: '100%',
    maxWidth: 'none',
  },
  primaryBlue: {
    backgroundColor: coreuiTokens.colorBlueBackground3,
    ...shorthands.borderColor('transparent'),
    color: tokens.colorNeutralForegroundOnBrand,

    ':hover': {
      backgroundColor: coreuiTokens.colorBlueBackground3Hover,
      ...shorthands.borderColor('transparent'),
      color: tokens.colorNeutralForegroundOnBrand,
    },

    ':hover:active': {
      backgroundColor: coreuiTokens.colorBlueBackground3Pressed,
      ...shorthands.borderColor('transparent'),
      color: tokens.colorNeutralForegroundOnBrand,
    },
  },
});

export const useClassNames = (
  fullWidth: boolean,
  className: string | undefined,
  isPrimaryBlue: boolean,
  isDisabled: boolean
) => {
  const classNames = useClasses();
  const usePrimaryBlueStyles = isPrimaryBlue && !isDisabled;

  return {
    root: mergeClasses(fullWidth && classNames.fullWidth, usePrimaryBlueStyles && classNames.primaryBlue, className),
  };
};
